import React from 'react';
import { DEFAULT_ADMIN_FEATURE_FLAGS } from '../constants/adminFeatureFlags';

export const FeatureFlagsContext = React.createContext(
  DEFAULT_ADMIN_FEATURE_FLAGS
);
